import { useState } from "react";
import type { SocialProfile } from "../types";

export function RankingPanel({ profile }: { profile: SocialProfile | null }) {
  const [ranking, setRanking] = useState<"depth" | "race" | "raid">("depth");
  const ranks = profile
    ? ranking === "depth"
      ? profile.depthGlobal
      : ranking === "race"
        ? profile.raceWeekly
        : profile.raidWeekly
    : [];
  return (
    <section className="social-pane" aria-label="排行榜">
      <div className="ranking-switch" role="group" aria-label="排行分类">
        {(
          [
            ["depth", "深度"],
            ["race", "竞速"],
            ["raid", "Raid"],
          ] as const
        ).map(([id, label]) => (
          <button
            key={id}
            className={ranking === id ? "is-active" : ""}
            aria-pressed={ranking === id}
            onClick={() => setRanking(id)}
          >
            {label}
          </button>
        ))}
      </div>
      {!profile ? (
        <p role="status">正在读取排行</p>
      ) : ranks.length === 0 ? (
        <p className="social-empty">本期暂无成绩</p>
      ) : (
        ranks.slice(0, 10).map((entry) => (
          <div className="ranking-row" key={`${entry.rank}-${entry.userId}`}>
            <strong>{entry.rank}</strong>
            <span>{entry.nickname}</span>
            <b>{entry.value}</b>
          </div>
        ))
      )}
    </section>
  );
}
